
const RegisterPaymentAdmin = () => {
    return (
        <div className="view-register-payment-admin">
        <h1>View Register Payment Admin</h1>
        <p>This component is designed to display register payment information for admin users.</p>
        {/* Additional content and functionality can be added here */}
        </div>
    );
}

export default RegisterPaymentAdmin;